import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { toast } from "react-toastify";
import { useEffect } from "react";

interface DashboardRouteProps {
  showToast?: boolean;
}

// This component protects dashboard routes that require authentication
// Server connectivity is handled by axios interceptors
const DashboardRoute = ({
  showToast = false,
}: DashboardRouteProps) => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  // Check if the current path should show a toast message
  const shouldShowToast = () => {
    const currentPath = location.pathname;
    return currentPath === "/cart" || currentPath === "/checkout";
  };

  useEffect(() => {
    // Show toast only if user is not authenticated and we're on a path that should show toast
    if (!isAuthenticated && shouldShowToast()) {
      toast.error("Please Login First", {
        position: "top-right",
        autoClose: 2000,
      });
    }
  }, [isAuthenticated, location.pathname]);

  // If user is not authenticated, redirect to login page
  if (!isAuthenticated) {
    // Show a toast message for all protected routes
    // toast.error("Please login to access this page", {
    //   position: "top-right",
    //   autoClose: 3000,
    // });
    return <Navigate to="/auth/login" replace />;
  }

  // Otherwise, render the protected dashboard route
  // Server connectivity will be handled by axios interceptors when API calls are made
  return <Outlet />;
};

export default DashboardRoute;
